<template>
  <div class="col-sm-12 nopads my-2">
    <Transition name="fade">
      <div
        v-if="results && results.length > 0"
        id="accordion"
        class="col-sm-12 panel-group data-container"
      >
        <div v-for="(result) in results" :key="result.company_id" class="data-list-item p-2">
            <license-summary-company-item :result="result" :date-from="dateFrom" :date-to="dateTo"/>
        </div>
      </div>
    </Transition>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {userHelper} from '../mixins/UserMixin'
import {restApi} from '../mixins/RestApiMixin'
import LicenseAdminReportTable from './LicenseAdminReportTable'
import LicenseSummaryCompanyItem from "@/components/licensereport/LicenseSummaryCompanyItem";


export default {
    name: 'LicenseSummaryTable',
    components: {LicenseSummaryCompanyItem, LicenseAdminReportTable},
    mixins: [userHelper, restApi],
    props: {
        dateFrom: {
            type: Number
        },
        dateTo: {
            type: Number
        },
        results: {
            type: Array,
            default() {
                return []
            }
        },
        allusers: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            users: [],
            lastinfo: '',
            userDataLoaded: false,
            loading: false,
            accordionOpen: false,
            fetched: false,
            fetchCallbacked: false,
            openAccordions: [],
            fetchedData: null,
            expiredRightsUsers: [],
            expiredRightsFetched: false,
        }
    },
    methods: {

    }
}
</script>
<style scoped>
.green {
    color: #7FC000;
}
</style>
